import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import type { Role } from '@mbs/shared';
import { session } from './lib/session';

const routes: RouteRecordRaw[] = [
  { path: '/login', component: () => import('./views/LoginView.vue'), meta: { public: true } },
  { path: '/', component: () => import('./views/HomeView.vue') },
  {
    path: '/register/:branch(dd|main)',
    component: () => import('./views/RegisterView.vue'),
    meta: { roles: ['registrar', 'dd_registrar'] as Role[] },
  },
  { path: '/student-ids', component: () => import('./views/StudentIdsView.vue') },
  { path: '/paid-applicants', component: () => import('./views/PaidApplicantsView.vue') },
  { path: '/dd-applicants', component: () => import('./views/DdApplicantsView.vue') },
  { path: '/failures', component: () => import('./views/FailuresView.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

export const router = createRouter({ history: createWebHistory(), routes });

/**
 * Route guards are convenience only — the Worker enforces the same roles on
 * every request, so a hand-typed URL gains nothing.
 */
router.beforeEach(async (to) => {
  if (!session.state.loaded) await session.load();
  if (to.meta.public) return true;
  if (!session.isAuthenticated.value) return { path: '/login', query: { next: to.fullPath } };

  const roles = to.meta.roles as Role[] | undefined;
  if (roles?.length && !session.can(...roles)) return { path: '/' };

  // Dembi Dollo registration additionally needs the DD role (§4).
  if (to.path === '/register/dd' && !session.can('dd_registrar')) return { path: '/' };
  if (to.path === '/register/main' && !session.can('registrar')) return { path: '/' };
  return true;
});
